// TEMPORARY compatibility file — post view tracking stub.

export async function trackPostView(_postId, _viewerId) {
  // TODO: restore real view tracking
  return { ok: true, stub: true };
}

export async function trackPostViewRPC(_postId, _viewerId) {
  // TODO: restore real RPC view tracking
  return { ok: true, stub: true };
}
